// Registrar SW o mais cedo possível (antes do React) para installability
import './lib/pwa/registerSW';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider, onlineManager } from '@tanstack/react-query';

import '@fontsource-variable/inter';

import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { UserScopedPersistence } from './components/UserScopedPersistence';
import { AuthProvider } from './context/AuthProvider';
import { initClarity } from './lib/observability/clarity';
import { initSentry } from './lib/observability/sentry';
import { createQueryClient } from './lib/queryClient';
import { initErrorTracking } from './services/errorTracking';
import './styles/global.css';

// Inicializar observabilidade antes do React render.
// Sentry primeiro para capturar erros nos demais inits.
// errorTracking permanece em paralelo (envia ao backend → CloudWatch).
initSentry();
initClarity();
initErrorTracking();

// Integrar React Query com status de rede
// Pausa refetches quando offline, retoma quando online
onlineManager.setEventListener((setOnline) => {
  const onlineHandler = () => setOnline(true);
  const offlineHandler = () => setOnline(false);
  window.addEventListener('online', onlineHandler);
  window.addEventListener('offline', offlineHandler);
  setOnline(navigator.onLine);
  return () => {
    window.removeEventListener('online', onlineHandler);
    window.removeEventListener('offline', offlineHandler);
  };
});

const queryClient = createQueryClient();

// Solicitar armazenamento persistente para evitar que o browser evicte dados do PWA
if (navigator.storage?.persist) {
  navigator.storage.persist();
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ErrorBoundary>
          <AuthProvider>
            <UserScopedPersistence>
              <App />
            </UserScopedPersistence>
          </AuthProvider>
        </ErrorBoundary>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
